import Dashboard                from '@pages/Dashboard';
import Profile                  from '@pages/profile/Profile';
import Account                  from '@pages/account/Account';
import AccountAdd               from '@pages/account/AccountAdd';
import AccountEdit              from '@pages/account/AccountEdit';
import EmailConfig              from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd           from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit          from '@pages/emailConfig/EmailConfigEdit';
import LoginHistory             from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory    from '@app/pages/report/countLogin/StatisticLoginHistory';
import Log                      from '@pages/log/Log';
import ApiRoleMapping           from '@app/pages/apiRoleMapping/ApiRoleMapping';
import ApiRoleMappingAdd        from '@app/pages/apiRoleMapping/ApiRoleMappingAdd';
import ApiRoleMappingEdit       from '@app/pages/apiRoleMapping/ApiRoleMappingEdit';

import { URI_INTERNAL } from './utils/pathLocations';
import OpeniddictApplication from '@app/pages/openiddictApplication/OpeniddictApplication';
import OpeniddictApplicationAdd from '@app/pages/openiddictApplication/OpeniddictApplicationAdd';
import OpeniddictApplicationEdit from '@app/pages/openiddictApplication/OpeniddictApplicationEdit';
import RoleAccount from '@app/pages/roleAccount/RoleAccount';
import RoleAccountAdd from '@app/pages/roleAccount/RoleAccountAdd';
import RoleAccountEdit from '@app/pages/roleAccount/RoleAccountEdit';
import KySo from '@app/pages/kySo/KySo';
import ProjectList from '@app/pages/project/ProjectList';
import ProjectAdd from '@app/pages/project/ProjectAdd';
import ProjectEdit from '@app/pages/project/ProjectEdit';
import ProjectKanban from '@app/pages/project/ProjectKanban';
import PersonalKanban from '@app/pages/project/PersonalKanban';

const rawRoutes = [
  // dashboard
  {
    path: "/", // bạn có thể thêm HOME_PATH = '/'
    exact: true,
    component: Dashboard,
    isPublic: false,
    controller: '',
    action:     '',
    label: "Dashboard",
    menu:       true,
    isPublic: false,
  },
  // Project
  {
    path: URI_INTERNAL.PROJECT_PATH,
    exact: true,
    component: ProjectList,
    isPublic: false,
    controller: 'Project',
    action:     '',
    label: "Quản lý dự án",
    menu:       true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PROJECT_PATH_ADD,
    exact: true,
    component: ProjectAdd,
    isPublic: false,
    controller: 'Project',
    action:     '',
    label: "",
    menu:       false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PROJECT_PATH_EDIT,
    exact: true,
    component: ProjectEdit,
    isPublic: false,
    controller: 'Project',
    action:     '',
    label: "",
    menu:       false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PROJECT_PATH_KANBAN,
    exact: true,
    component: ProjectKanban,
    isPublic: false,
    controller: 'Project',
    action:     '',
    label: "",
    menu:       false,
    isPublic: false,
  },
  {
    path: '/project/personal-kanban',
    exact: true,
    component: PersonalKanban,
    isPublic: false,
    controller: 'PersonalTask',
    action:     '',
    label: "Nhiệm vụ cá nhân",
    menu:       true,
    isPublic: false,
  },
  // profile
  {
    path: "/profile",
    exact: true,
    component: Profile,
    isPublic: false,
    // controller: 'Profile',
    // action:     'View',
    // label:      'Profile',
    controller: '',
    action:     '',
    label: "Thông tin cá nhân",
    menu:       false,
    isPublic: false,
  },
  // account
  {
    path: URI_INTERNAL.ACCOUNT_PATH,
    exact: true,
    component: Account,
    isPublic: false,
    controller: 'Account',
    // controller: '',
    action:     '',
    label: "Tài khoản",
    menu:       true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_ADD,
    exact: true,
    component: AccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action:     '',
    label: "",
    menu:       false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_EDIT,
    exact: true,
    component: AccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action:     '',
    label: "",
    menu:       false,
    isPublic: false,
  },
  //role
   {
    path: URI_INTERNAL.ROLE_ACCOUNT_PATH,
    exact: true,
    component: RoleAccount,
    isPublic: false,
    controller: 'Role',
    // controller: '',
    action:     '',
    label: "Quyền",
    menu:       true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_CREATE_PATH,
    exact: true,
    component: RoleAccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action:     '',
    label: "",
    menu:       false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_EDIT_PATH,
    exact: true,
    component: RoleAccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action:     '',
    label: "",
    menu:       false,
    isPublic: false,
  },
  // email config
  {
    path: URI_INTERNAL.EMAILCONFIG_PATH,
    exact: true,
    component: EmailConfig,
    isPublic: false,
    controller: 'EmailConfig',
    // controller: '',
    action:     '',
    label: "Email gửi thông báo",
    menu:       true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_CREATE_PATH,
    exact: true,
    component: EmailConfigAdd,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action:     '',
    label: "",
    menu:       false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_EDIT_PATH,
    exact: true,
    component: EmailConfigEdit,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action:     '',
    label: "",
    menu:       false,
    isPublic: false,
  },
  // reports
  {
    path: URI_INTERNAL.LOGIN_HISTORY_PATH,
    exact: true,
    component: LoginHistory,
    isPublic: false,
    controller: 'LoginHistory',
    // controller: '',
    action:     '',
    label: "Lịch sử đăng nhập",
    menu:       true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.STATISTIC_HISTORY_PATH,
    exact: true,
    component: StatisticLoginHistory,
    isPublic: false,
    // controller: 'Report',
    controller: '',
    action:     '',
    label: "Thống kê lịch sử đăng nhập",
    menu:       true,
    isPublic: false,
  },
  // api-role-mapping
  {
    path: URI_INTERNAL.APIROLEMAPPING_PATH,
    exact: true,
    component: ApiRoleMapping,
    isPublic: false,
    controller: 'ApiRoleMapping',
    // controller: '',
    action:     '',
    label: "Phân quyền API",
    menu:       true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_CREATE_PATH,
    exact: true,
    component: ApiRoleMappingAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu:       false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
    exact: true,
    component: ApiRoleMappingEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu:       false,
    isPublic: false,
  },
   {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_PATH,
    exact: true,
    component: OpeniddictApplication,
    isPublic: false,
    controller: 'OpeniddictApplication',
    // controller: '',
    action:     '',
    label: "Ứng dụng đăng ký",
    menu:       true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_CREATE_PATH,
    exact: true,
    component: OpeniddictApplicationAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu:       false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_EDIT_PATH,
    exact: true,
    component: OpeniddictApplicationEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu:       false,
    isPublic: false,
  },
  // log
  {
    path: URI_INTERNAL.LOG_PATH,
    exact: true,
    component: Log,
    isPublic: false,
    controller: 'Log',
    // controller: '',
    action:     '',
    label: "Xem log",
    menu:       true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.KYSO_PATH,
    exact: true,
    component: KySo,
    isPublic: false,
    controller: 'KySo',
    // controller: '',
    action:     '',
    label: "Ký số",
    menu:       true,
    isPublic: false,
  },
];

// function withController(routes) {
//   return routes.map(r => {
//     const name = r.component.displayName || r.component.name || '';
//     return {
//       ...r,
//       controller: r.controller ? r.controller : name,
//       // nếu chưa có label thì lấy tên component
//       label: r.label || name,
//     };
//   });
// }

function withController(routes) {
  return routes.map(r => ({
    ...r,
    // controller: r.controller,
    label: r.label || r.controller,
  }));
}

export const appRoutes = withController(rawRoutes);

export const menuGroups = [
  {
    title: "Dự án",
    icon:  "fas fa-project-diagram",
    children: appRoutes.filter(r =>
      r.menu && [
        "Project",
        "PersonalTask"
      ].includes(r.controller)
    )
  },
  {
    title: "Hệ thống",
    icon:  "fas fa-cog",
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && [
        "Account",
        "Role",
        "EmailConfig",
        "ApiRoleMapping",
        "OpeniddictApplication",
        "Log",
        "KySo",
      ].includes(r.controller)
    )
  },
  {
    title: "Báo cáo",
    icon:  "fas fa-table",
    // Lấy tất cả route menu thuộc nhóm Báo cáo
    children: appRoutes.filter(r =>
      r.menu && [
        "LoginHistory",
        "StatisticLoginHistory"
      ].includes(r.controller)
    )
  }
];
